import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Icon from "./icon/icon.component.jsx"
import GlobalHelper from './GlobalHelper.jsx'
import ShopifyAppContext from '../shopify/shopifyappcontext.js'

class ErrorBoundary extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = { hasError: false }
        this.refresh = this.refresh.bind(this)
    }

    refresh(e) {
        e.preventDefault()
        if (GlobalHelper.getShopifyIntegrationOrigin()) {
            ShopifyAppContext.redirectTo(`/?r=${window.location.pathname}`)
        } else {
            window.location.reload()
        }
    }

    render() {
        // You can render any custom fallback UI
        return <div className="container">
            <div className="row justify-content-md-center">
                <div className="col-8" style={{ marginTop: '200px' }}>
                    <p className="lead text-center">
                        <Icon value={"exclamation"} style={{ fontSize: '35px' }} />
                        &nbsp;
                        Oops... There was an unexpected error, please refresh or try again later
                        <br />
                        <a href={'#'} className={'btn btn-primary'} onClick={this.refresh}>
                            <Icon value={'sync'} className={'mr-1'} />
                            Refresh
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }
}

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/common/error.component.jsx